import React, { useMemo } from 'react';
import { EXPERIMENT_PAGE_DESIGN_FLAGS } from '../../../../experiments/constants';
import { useExperimentContext } from '../../../../experiments/context';
import { getEnabledVariant } from '../../../../experiments/utils';
import { useSubscriptionPlanContext } from '../../../../subscriptionPlans/context';
import { getPlanOrder, getVariantCopies, sortPlans } from './paymentModuleData';
import { getPlanDataKeyExperimentOverrides, getPlansDisplayData } from './plansDisplayData';

import { useIsMobile } from '../../../../hooks/screenSizeHooks';

function PriceModuleVariantWrapper(props) {
  const isMobile = useIsMobile();

  const { experiments } = useExperimentContext();
  const enabledVariant = getEnabledVariant(experiments, [
    'paymentModuleVariant1',
    'paymentModuleVariant2',
    ...EXPERIMENT_PAGE_DESIGN_FLAGS,
  ]);
  const { plans, selectedOffer } = useSubscriptionPlanContext();

  const { component: Component, ...variantCopies } = useMemo(
    () => getVariantCopies(enabledVariant),
    [enabledVariant]
  );

  const planOrder = getPlanOrder({ isMobile, enabledExperiment: enabledVariant });

  const sortedPlans = sortPlans(plans, planOrder);
  const planOptionsData = useMemo(
    () =>
      getPlansDisplayData({
        planOptions: sortedPlans,
        planDataKeyOverrides: getPlanDataKeyExperimentOverrides(enabledVariant),
      }),
    [plans, planOrder]
  );

  if (!enabledVariant || !plans.length) {
    return null;
  }

  return (
    <Component
      // Legacy subscriptionPlans prop, but needed for the first plan selector module experiment
      subscriptionPlans={sortedPlans}
      selectedOffer={selectedOffer}
      {...props}
      {...variantCopies}
      variant={enabledVariant}
      planOptionsData={planOptionsData}
    />
  );
}

export default PriceModuleVariantWrapper;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/index.js